import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import { formatPrice } from '../../../../utils/formatter'
import {
  ProductItemContainer,
  ProductItem,
  ProductImageContainer,
  ProductImage,
  ProductInfoContainer,
  ProductName,
  ProductDescription,
  ProductPrice,
  QuantityBadge,
  ProductUpperRow,
} from './styled'
import Loading from '../../../../components/Loading'
const ProductOrderSheet = loadable(() => import('./ProductOrderSheet'))

function ProductListItem({
  addToBasket, product, basket, selected, onClick, category,
}) {
  const productRowRef = useRef()

  // useEffect(() => {
  //   if (selected && productRowRef.current && tabBarRef.current) {
  //     const top = productRowRef.current.offsetTop - tabBarRef.current.offsetHeight - safeAreaInsets.top - headerHeight
  //     window.scrollTo({ top, behavior: 'smooth' })
  //   }
  // }, [selected])

  function handleClick() {
    onClick(product)
  }

  function handleAdd(values) {
    addToBasket(values)
  }

  const quantityInBasket = basket && (basket.items || []).reduce((sum, item) => item.product_id === product.id ? sum + item.quantity : sum, 0)

  return (
    <React.Fragment>
      <ProductItemContainer ref={productRowRef} key={product.id} onClick={handleClick}>
        <ProductItem>
          <ProductImageContainer>
            <ProductImage src={product.image || category.icon || 'https://content.pickpack.de/fit/90x90/foil1/_products_/placeholder/shoppingbag_v2.png'} />
            {!!quantityInBasket && <QuantityBadge>{quantityInBasket}</QuantityBadge>}
          </ProductImageContainer>
          <ProductInfoContainer>
            <ProductUpperRow>
              <ProductName>{product.name}</ProductName>
              <ProductPrice discounted={!!product.old_price || product.is_promo}>
                {formatPrice(product.price)}
              </ProductPrice>
            </ProductUpperRow>
            <ProductDescription>{product.teaser_text}</ProductDescription>
          </ProductInfoContainer>
        </ProductItem>
      </ProductItemContainer>
      {/* Drawer */}
      {selected && (
        <ProductOrderSheet
          fallback={<Loading />}
          product={product}
          addToBasket={handleAdd}
        />
      )}
    </React.Fragment>
  )
}

ProductListItem.propTypes = {
  product: PropTypes.object.isRequired,
  addToBasket: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  basket: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  category: PropTypes.object.isRequired,
  // tabBarRef: PropTypes.object.isRequired,
  // headerHeight: PropTypes.number.isRequired,
}

ProductListItem.defaultProps = {
  selected: false,
  basket: null,
}

export default ProductListItem
